/**
 * @file    tabs.ts
 * @scope   SHARED
 * @summary Tab identity for the drawer's main view. Enterprise sub-views declare their own tabs
 *          inside `components/DiyEnterprise/Views/*` and are re-exported by `Enterprise/`.
 * @consumes components/TabNavigator/TabNavigator (Tab type)
 * @produces DiyDrawerMainTab
 * @sideEffects None.
 */
import { Tab } from 'components/TabNavigator/TabNavigator';

/**
 * Root tab of the drawer. `TabNavigator` uses it as the breadcrumb origin, and every
 * "back to main" action navigates here.
 */
export const DiyDrawerMainTab: Tab = { name: 'main', displayName: 'Edit Widget' };
